import { render, staticRenderFns } from "./parser.vue?vue&type=template&id=40742e3c&"
import script from "./parser.vue?vue&type=script&lang=js&"
export * from "./parser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports